import { render, staticRenderFns } from "./bottomIndex.vue?vue&type=template&id=57a254bb&scoped=true"
import script from "./bottomIndex.vue?vue&type=script&lang=js"
export * from "./bottomIndex.vue?vue&type=script&lang=js"
import style0 from "./bottomIndex.vue?vue&type=style&index=0&id=57a254bb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57a254bb",
  null
  
)

export default component.exports